import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getEasternTime, getMonthDayYear, getTimeHrMin } from '../../helpers/dateHelpers';
import { useSdoAdminReportsProvider } from '../../providers/SdoAdminReportsProvider';
import HorizontalProgressBar from '../HorizontalProgressBar/HorizontalProgressBar';
import Loader from '../Loader/Loader';
import './SdoAdminReportDetailsStatus.scss'
import { isPublishedWithOtherReqs, positionPublishStatus } from './SdoAdminReportHelper';
import SdoAdminReportPositions from './SdoAdminReportPositions';

export default function SdoAdminReportDetailsStatus({positionsPublishData, setPosition}) {
    const { t } = useTranslation();
    const sdoAdminReportsContext = useSdoAdminReportsProvider();
    const [viewCount, setViewCount] = useState(8);
    const [pendingPositions,setPendingPositions] = useState<any>([]);
    const [publishedPositions,setPublishedPositions] = useState<any>([]);
    const [eipPublishedDate, setEipPublishedDate] = useState<Date | string | any>('');    

    const showAll = () => {
        setViewCount(Number(positionsPublishData?.totalPending) > Number(positionsPublishData?.totalPublished) ? Number(positionsPublishData?.totalPending) : Number(positionsPublishData?.totalPublished));
    }

    const showLess = () => {
        setViewCount(8);
    }

    const onClickPosition = (position) => {
        setPosition(position);
    }

    const getProgressValue = () => {
        if(!positionsPublishData?.totalPublished && !positionsPublishData?.totalPending) return 0;
        return ((100 * Number(positionsPublishData?.totalPublished)) / (Number(positionsPublishData?.totalPublished) + Number(positionsPublishData?.totalPending)));
    }

    const getTotalPositions = () => {
        if(!positionsPublishData) return 0;

        return Number(positionsPublishData?.totalPublished) + Number(positionsPublishData?.totalPending);
    }

    useEffect(()=>{
        if(!positionsPublishData?.positions) return;

        setPendingPositions(positionsPublishData?.positions?.filter(position => position.status === positionPublishStatus.PENDING));
        setPublishedPositions(positionsPublishData?.positions?.filter(position => isPublishedWithOtherReqs(position)));

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[positionsPublishData]);    

    useEffect(() => {
        if (!sdoAdminReportsContext || !sdoAdminReportsContext?.sdoCurrentSubPeriodData) return;

        setEipPublishedDate(sdoAdminReportsContext?.sdoCurrentSubPeriodData?.eipDeliveredDate);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sdoAdminReportsContext.sdoCurrentSubPeriodData]);

    return (
        sdoAdminReportsContext.positionsPublishLoading ? <Loader /> : (
            <div className='sdo-report-status__main'>
                <div className='sdo-report-status__container'>
                    <div className='sdo-report-status__status'>
                        <p className='sdo-report-status__status--title'>
                            {t('specialDayOffAdmin.specialDayOffAdminReportDetails.status')}
                        </p>
                        <HorizontalProgressBar height={16} value={getProgressValue()} />
                        <div className='sdo-report-status__status--label'>
                            <span className='sdo-report-status__label-published'>{positionsPublishData?.totalPublished ?? 0}</span>
                            {t('specialDayOffAdmin.specialDayOffAdminReportDetails.published', { totalPositions: getTotalPositions() })}
                        </div>
                        {
                        eipPublishedDate && eipPublishedDate.length ? 
                        <p>{t('specialDayOffAdmin.specialDayOffAdminReportDetails.deliveredToEip', { date: `${getMonthDayYear(getEasternTime(eipPublishedDate))} ${getTimeHrMin(getEasternTime(eipPublishedDate))}` })}</p> 
                        :''
                        }
                    </div>
                    <div className='sdo-report-status__positions'>
                        {positionsPublishData?.totalPending ? 
                        <>
                            <p className='sdo-report-status__positions--label'>{t('specialDayOffAdmin.specialDayOffAdminReportDetails.pendingPositions')}</p>
                            <div className='sdo-report-status__positions-base' >
                                {
                                    pendingPositions && pendingPositions.length && pendingPositions.map((position, index) => {
                                        if (index < viewCount){
                                            return (
                                                <div onClick={() => onClickPosition(position)} key={index}>
                                                    <SdoAdminReportPositions position={position}/>
                                                </div>
                                            )
                                        }
                                        else return <div key={index}></div>
                                    })
                                }
                            </div>
                        </>
                        :''
                        }
                        {positionsPublishData?.totalPublished ? 
                        <>
                            <p className='sdo-report-status__positions-published--label'>{t('specialDayOffAdmin.specialDayOffAdminReportDetails.publishedPositions')}</p>
                            <div className='sdo-report-status__positions-base' >
                                {
                                    publishedPositions && publishedPositions.length && publishedPositions.map((position, index) => {
                                        if (index < viewCount){
                                            return (
                                                <div onClick={() => onClickPosition(position)} key={index}>
                                                    <SdoAdminReportPositions position={position}/>
                                                </div>
                                            )
                                        }
                                        else return <div key={index}></div>
                                    })
                                }
                            </div>
                        </>
                        :''}
                        
                        {(publishedPositions?.length > 8 || pendingPositions?.length > 8) && <div className='sdo-report-status__positions-buttons'>
                            {viewCount === 8 ? <button className='sdo-report-status__button-view' onClick={() => showAll()}> {t('specialDayOffAdmin.specialDayOffAdminReportDetails.viewAll')} <i className="icon-chevron-thin-down sdo-report-status__view--all"></i> </button> :
                                <button className='sdo-report-status__button-view' onClick={() => showLess()}> {t('specialDayOffAdmin.specialDayOffAdminReportDetails.viewLess')} <i className="icon-chevron-thin-down sdo-report-status__view--less"></i></button>}
                        </div>}
                    </div>
                </div>
            </div>
        )
    )
}
